// extracted by mini-css-extract-plugin
export default {"page-row":"styles-module_page-row__iCsyRc","page-row-half":"styles-module_page-row-half__caakSX","page-row-normal":"styles-module_page-row-normal__kJ6bZW"};